import React, { useState } from "react";
import { StyledTable } from "atoms/Table";
import { ReactComponent as Dateicon } from "../../../assets/icons/Vector.svg";
import styled from "styled-components";
import { Button, message, Modal } from "antd";
import Viewmodal from "../../Appraisals/Viewmodal";
import { useHistory } from "react-router-dom";
import { ReactComponent as Tick } from "../../../assets/icons/tick.svg";
import moment from "moment";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import user from "../../../assets/employeeinfo.svg";
import { EmployeeInfo } from "../EmployeeInfo";
import { useSelector } from "react-redux";
import { getUserList } from "redux/selectors";
import axios from "axios";
import { ButtonFilled } from "reusableComponent/UIButtons";

const Styleddiv = styled.div`
  .title {
    color: #636980;
  }
  .wrapped-header {
    white-space: normal !important;
    ${"" /* text-align: center; */}
  }
  .footer {
    position: fixed;
    bottom: 0;
    right: 0;
    width: 100%; /* Full width if needed */
    display: flex;
    justify-content: flex-end !important;
    padding: 12px 24px;
    background: white;
    box-shadow: 0px -2px 10px rgba(0, 0, 0, 0.1);
    z-index: 1000;
  }
  .footer-button {
    min-width: 100px;
    height: 40px;
    font-size: 16px;
  }
`;
function Agreed() {
  const userList = useSelector(getUserList);
  const history = useHistory();
  const location = useLocation();
  const performanceList = location?.state?.performanceList || {};
  const [isModalVisible, setIsModalVisible] = useState(false);
  const handleCancelModal = () => setIsModalVisible(false);
  const showModal = () => setIsModalVisible(true);
  const [loader, setLoader] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [isPdfModalOpen, setIsPdfModalOpen] = useState(false);

  const selectedUser = userList?.find(
    (item) => item?.userid === performanceList?.apraiseemailid
  );

  const findJobDescription = selectedUser?.appraisalInformation?.find(
    (item) => item?.roletype === performanceList?.roletype
  );

  const selectedEmployee = {};
  const formatData = (list, keyName) =>
    (list || []).map((item, index) => ({
      key: `${keyName}-${index + 1}`,
      Slno: index + 1,
      Targetobjectives:
        item.straobjorgstartegy ||
        item.previousappraisalperiod ||
        item.upcomingappraisalperiod ||
        "---",
      ExpectedOutcomes: item.expectedoutcome || "---",
      TargetDate: item.TargetDate,
      Weightage: item.Weightage,
    }));

  const strategicData = formatData(
    performanceList?.startegicobjectives,
    "strategic"
  );
  const rolloverData = formatData(
    performanceList?.rolloverresponsibility,
    "rollover"
  );
  const upcomingData = formatData(
    performanceList?.upcomingappraisalperiod,
    "upcoming"
  );
  const baseColumns = [
    {
      title: "Sl.no",
      dataIndex: "Slno",
      key: "Slno",
    },
    {
      title: "", // <-- will be customized per table
      dataIndex: "Targetobjectives",
      key: "Targetobjectives",
      className: "wrapped-header",
      width: "30%",
    },
    {
      title: "Expected Outcomes",
      dataIndex: "ExpectedOutcomes",
      key: "ExpectedOutcomes",
      className: "wrapped-header",
      width: "30%",
    },
    {
      title: "Target Date",
      dataIndex: "TargetDate",
      key: "TargetDate",
      render: (text) => (
        <>
          <Dateicon style={{ marginRight: "10px" }} />
          {moment(text).format("DD-MM-YYYY")}
        </>
      ),
    },
    {
      title: "Weightage",
      dataIndex: "Weightage",
      key: "Weightage",
    },
  ];

  // Clone and customize column sets
  const strategicColumns = baseColumns.map((col) =>
    col.dataIndex === "Targetobjectives"
      ? {
        ...col,
        title: (
          <div style={{ whiteSpace: "normal" }}>
            Strategic Objectives aligned to Organisational Strategy
            <br />
            for the upcoming appraisal period
          </div>
        ),
      }
      : col
  );

  const rolloverColumns = baseColumns.map((col) =>
    col.dataIndex === "Targetobjectives"
      ? {
        ...col,
        title: (
          <div style={{ whiteSpace: "normal" }}>
            Objectives that Rolled over from Previous Appraisal Period
          </div>
        ),
      }
      : col
  );

  const upcomingColumns = baseColumns.map((col) =>
    col.dataIndex === "Targetobjectives"
      ? {
        ...col,
        title: (
          <div style={{ whiteSpace: "normal" }}>
            Target Objectives aligned to Organisational Strategy
            <br />
            for the upcoming appraisal period
          </div>
        ),
      }
      : col
  );

  const viewJobDescription = async () => {
    if (
      !findJobDescription?.jobDescriptionId ||
      !findJobDescription?.jobdescriptionFileName
    ) {
      message.warning("User has not created a Job Description.");
      return;
    }
    const token = window.localStorage.getItem("token") || "";
    try {
      setLoader(true);
      const response = await axios.get(
        "https://axcxv4d066.execute-api.ap-south-1.amazonaws.com/Prod/appraisal/getdocument",
        {
          params: {
            jobdescriptionid: findJobDescription?.jobDescriptionId,
            filename: findJobDescription?.jobdescriptionFileName,
          },
          headers: { Insytsjwt: token },
        }
      );
      if (response?.data?.status === "SUCCESS" && response?.data?.url) {
        setPdfUrl(response.data.url);
        setIsPdfModalOpen(true);
      } else {
        message.error(response?.data?.message || "Failed to fetch document.");
        setLoader(false);
      }
    } catch (error) {
      message.error(error?.message || "Failed to fetch document.");
      setLoader(false);
    } finally {
      setLoader(false);
    }
  };

  return (
    <div style={{ marginBottom: "100px" }}>
      <Modal
        open={isPdfModalOpen}
        onCancel={() => setIsPdfModalOpen(false)}
        footer={null}
        width={1000}
        centered
        bodyStyle={{ height: "80vh", padding: 0 }}
      >
        {pdfUrl ? (
          <iframe
            src={pdfUrl}
            title="PDF Preview"
            width="100%"
            height="100%"
            style={{ border: "none" }}
          />
        ) : (
          <p style={{ textAlign: "center", paddingTop: "40%" }}>Loading...</p>
        )}
      </Modal>
      <Styleddiv>
        <h6>
          <span
            className="title"
            onClick={() => history.push("/performancemanagement")}
          >
            Appraisal{" "}
          </span>
          <span>&gt;</span>
          {performanceList?.contractstatus === "created" ||
            performanceList?.contractstatus === "resend" ||
            performanceList?.contractstatus === "updated"
            ? "Yet to Accepted"
            : performanceList?.contractstatus === "accepted" ||
              performanceList?.contractstatus === "attended"
              ? "Accepted"
              : performanceList?.contractstatus === "declined"
                ? "Declined"
                : ""}
        </h6>
        <br />
        <h6>
          {performanceList?.roletype} Role - Key responsibilities / targets for
          the upcoming appraisal
        </h6>
        <br />

        <h6>Strategic Objectives</h6>
        <StyledTable
          columns={strategicColumns}
          dataSource={strategicData}
          pagination={false}
        />
        <br />

        {rolloverData?.length > 0 && (
          <div className="table-container">
            <div className="d-flex justify-content-between align-items-cente">
              <h6>Rollover Responsibility from Previous Appraisal</h6>
              <p
                className="mb-0 pb-0"
                onClick={() => viewJobDescription()}
                style={{
                  color: "#1890ff",
                  textDecoration: "underline",
                  fontSize: "16px",
                  cursor: "pointer",
                }}
              >
                Job Description
              </p>
            </div>
            <StyledTable
              columns={rolloverColumns}
              dataSource={rolloverData}
              pagination={false}
            />
          </div>
        )}
        <div className="table-container mt-3">
          <div className="d-flex justify-content-between align-items-center">
            <h6>Objectives from JD for the Upcoming Appraisal Period</h6>
            <p
              className="mb-0 pb-0"
              onClick={() => viewJobDescription()}
              style={{
                color: "#1890ff",
                textDecoration: "underline",
                fontSize: "16px",
                cursor: "pointer",
              }}
            >
              Job Description
            </p>
          </div>

          <StyledTable
            columns={upcomingColumns}
            dataSource={upcomingData}
            pagination={false}
          />
          <br />
        </div>
      </Styleddiv>
      {performanceList?.contractstatus === "declined" && (
        <div className="mb-5">
          <h6>Reason for Decline</h6>
          <div
            className="w-100 p-2 mb-5"
            style={{
              background: "#E4E4E4",
              marginBottom: "50px",
              borderRadius: "5px",
            }}
          >
            {performanceList?.reason}
          </div>
        </div>
      )}
      <div
        className="footer"
        style={{ display: "flex", justifyContent: "flex-end" }}
      >
        <ButtonFilled
          className="footer-button"
          onClick={() => history.push("/performancemanagement")}
        >
          Back
        </ButtonFilled>
      </div>
      <img
        src={user}
        alt="Floating User Icon"
        style={{
          position: "fixed",
          bottom: "10px",
          right: "50px",
          width: "100px",
          height: "100px",
          borderRadius: "50%",
          zIndex: 1000,
          cursor: "pointer",
        }}
        onClick={showModal}
      />
      <EmployeeInfo
        isModalVisible={isModalVisible}
        handleCancelModal={handleCancelModal}
        selectedEmployee={selectedUser}
      />
    </div>
  );
}

export default Agreed;
